// History Page
import { motion } from "framer-motion";
import { ArrowLeft, Clock } from "lucide-react";
import { SBER, pageVariants, tapAnimation } from "../utils/constants";
import { SberCard, TransactionItem } from "../components/UIComponents";

const HistoryPage = ({ transactions, onBack, t }) => (
  <motion.div 
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
    className="min-h-screen pb-28"
    style={{ background: SBER.bg }}
  >
    <div className="px-5 pt-5 pb-4 flex items-center gap-3" style={{ background: SBER.white }}>
      <motion.button 
        whileTap={tapAnimation}
        onClick={onBack}
        className="w-10 h-10 rounded-full flex items-center justify-center"
        style={{ background: SBER.grayPale }}
      >
        <ArrowLeft className="w-5 h-5" style={{ color: SBER.gray }} />
      </motion.button>
      <h1 className="text-[18px] font-semibold" style={{ color: SBER.dark }}>
        {t('history.title')}
      </h1>
    </div>
    
    <div className="px-5 pt-5">
      {transactions.length === 0 ? (
        <SberCard className="p-8 text-center">
          <div 
            className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-3"
            style={{ background: SBER.greenPale }}
          >
            <Clock className="w-6 h-6" style={{ color: SBER.green }} />
          </div>
          <p className="font-medium" style={{ color: SBER.gray }}>{t('history.noHistory')}</p>
          <p className="text-[13px] mt-1" style={{ color: SBER.grayLight }}>{t('home.topUpBalance')}</p>
        </SberCard>
      ) : (
        <div className="space-y-2">
          {transactions.map((tx, idx) => (
            <TransactionItem key={tx.id || idx} tx={tx} t={t} />
          ))}
        </div>
      )}
    </div>
  </motion.div>
);

export default HistoryPage;
